export const TravelPhotos = [
    { "imgUrl": "../pi/l/Travel/t (1).jpg", },
    { "imgUrl": "../pi/l/Travel/t (2).jpg", },
    { "imgUrl": "../pi/l/Travel/t (3).jpg", },
    { "imgUrl": "../pi/l/Travel/t (4).jpg", },
    { "imgUrl": "../pi/l/Travel/t (5).jpg", },
    { "imgUrl": "../pi/l/Travel/t (6).jpg", },
    { "imgUrl": "../pi/l/Travel/t (7).jpg", },
    { "imgUrl": "../pi/l/Travel/t (8).jpg", },
    { "imgUrl": "../pi/l/Travel/t (9).jpg", },
    { "imgUrl": "../pi/l/Travel/t (10).jpg", },
    { "imgUrl": "../pi/l/Travel/t (25).jpg", },
    { "imgUrl": "../pi/l/Travel/t (12).jpg", },
    { "imgUrl": "../pi/l/Travel/t (13).jpg", },
    { "imgUrl": "../pi/l/Travel/t (14).jpg", },
    { "imgUrl": "../pi/l/Travel/t (36).jpg", },
    { "imgUrl": "../pi/l/Travel/t (37).jpg", },
    { "imgUrl": "../pi/l/Travel/t (38).jpg", },
    { "imgUrl": "../pi/p/Travel/t (1).jpg", },
    { "imgUrl": "../pi/p/Travel/t (2).jpg", },
    { "imgUrl": "../pi/p/Travel/t (3).jpg", },
    { "imgUrl": "../pi/l/Travel/t (15).jpg", },
    { "imgUrl": "../pi/l/Travel/t (16).jpg", },
    { "imgUrl": "../pi/l/Travel/t (17).jpg", },
    { "imgUrl": "../pi/l/Travel/t (18).jpg", },
    { "imgUrl": "../pi/l/Travel/t (19).jpg", },
    { "imgUrl": "../pi/l/Travel/t (32).jpg", },
    { "imgUrl": "../pi/l/Travel/t (33).jpg", },
    { "imgUrl": "../pi/l/Travel/t (34).jpg", },
    { "imgUrl": "../pi/l/Travel/t (35).jpg", },
    { "imgUrl": "../pi/p/Travel/t (4).jpg", },
    { "imgUrl": "../pi/p/Travel/t (5).jpg", },
    { "imgUrl": "../pi/p/Travel/t (6).jpg", },
    { "imgUrl": "../pi/l/Travel/t (20).jpg", },
    { "imgUrl": "../pi/l/Travel/t (21).jpg", },
    { "imgUrl": "../pi/l/Travel/t (22).jpg", },
    { "imgUrl": "../pi/l/Travel/t (23).jpg", },
    { "imgUrl": "../pi/l/Travel/t (24).jpg", },
    { "imgUrl": "../pi/l/Travel/t (11).jpg", },
    { "imgUrl": "../pi/l/Travel/t (26).jpg", },
    { "imgUrl": "../pi/l/Travel/t (27).jpg", },
    { "imgUrl": "../pi/l/Travel/t (28).jpg", },
    { "imgUrl": "../pi/l/Travel/t (29).jpg", },
    { "imgUrl": "../pi/l/Travel/t (30).jpg", },
    { "imgUrl": "../pi/l/Travel/t (31).jpg", },
    { "imgUrl": "../pi/p/Travel/t (7).jpg", },
    { "imgUrl": "../pi/p/Travel/t (8).jpg", },
    { "imgUrl": "../pi/p/Travel/t (9).jpg", },
]